import { render, staticRenderFns } from "./CollectionsAging.vue?vue&type=template&id=1beefa08&scoped=true&"
import script from "./CollectionsAging.vue?vue&type=script&lang=ts&"
export * from "./CollectionsAging.vue?vue&type=script&lang=ts&"
import style0 from "./CollectionsAging.vue?vue&type=style&index=0&id=1beefa08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1beefa08",
  null
  
)

export default component.exports